import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const vacationSlider = () => {
    new Swiper('.swiper-container-vacation', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 3000,
        },
        speed: 800,
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.swiper-vacation-next',
            prevEl: '.swiper-vacation-prev',
        },
    });
};

export { vacationSlider as default };
